import { z } from "zod";


export const PgtoInformacaoCadastroSchema = z.object({
    idPgtoContratoFinanceiro: z.number().optional().nullable(),

    valorReceber: z.coerce.number().optional().nullable(),
    valorRecebido: z.coerce.number().optional().nullable(),
    dataReceber: z.coerce.date().optional().nullable(),
    dataRecebido: z.coerce.date().optional().nullable(),
    tipo: z.coerce.number().optional().nullable(),

    observacao: z.coerce.string().max(249, "Observação deve ter no máximo 249 caracteres.").optional().nullable(),

});

export type PgtoInformacaoCadastroForm = z.infer<typeof PgtoInformacaoCadastroSchema>;

export const defaultPgtoInformacaoCadastroForm: Partial<PgtoInformacaoCadastroForm> = {


}